export default __webpack_public_path__ + "static/media/ai_LED.943c9cad.svg";